import dayjs from 'dayjs'
import { useMemo } from 'react'

import { useLineChart } from '@/pages/ui/line-chart/use-line-chart'
import { toDecimalYear } from '@/pages/ui/utils'

import { cn } from '@/lib/utils'

export interface VisaBulletinTrendChartMyPriorityDateProps {
  priorityDate?: string
}

export const VisaBulletinTrendChartMyPriorityDate: React.FC<VisaBulletinTrendChartMyPriorityDateProps> = ({
  priorityDate,
}) => {
  const { yScale, activeIndex, plotAreaWidth, plotAreaHeight, plotAreaPadding } = useLineChart()

  const y = useMemo(() => {
    if (!priorityDate) {
      return null
    }

    const fractionalYear = toDecimalYear(priorityDate)

    return Math.max(-10, yScale(fractionalYear))
  }, [priorityDate, yScale])

  if (y === null) {
    return null
  }

  if (y >= plotAreaHeight + (plotAreaPadding?.top ?? 0)) {
    return null
  }

  return (
    <g key={y}>
      <g transform={`translate(-13, ${y - 10})`}>
        <foreignObject width="140" height="20">
          <div
            className={cn(
              'flex items-center',
              'duration-200 animate-in fade-in slide-in-from-bottom-1',
              activeIndex !== null && 'opacity-30'
            )}
          >
            <div className="h-[20px] rounded-[5px] bg-[white] px-[8px] text-xs font-medium leading-[20px] text-slate-600">
              Your priority date
            </div>
          </div>
        </foreignObject>
      </g>

      <line x1="98" y1={y} x2={plotAreaWidth ?? 0 + 40} y2={y} className="stroke-slate-400" strokeDasharray="2 2" />

      <g transform={`translate(${plotAreaWidth ?? 0 + 25}, ${y - 10})`}>
        <foreignObject width="100" height="20">
          <div
            className={cn(
              'flex items-center justify-center',
              'duration-200 animate-in fade-in slide-in-from-bottom-1',
              activeIndex !== null && 'opacity-30'
            )}
          >
            <div className="h-[20px] rounded-[5px] bg-[#334155] px-[5px] text-xs font-medium leading-[20px] text-white">
              {dayjs(priorityDate).format('MMM D, YYYY')}
            </div>
          </div>
        </foreignObject>
      </g>
    </g>
  )
}
